module.exports = __webpack_public_path__ + "img/logo_header_new.5cb12c1b.svg";